module.exports = __webpack_public_path__ + "static/media/Poppins-Semibold-devanagari.79e6e81d.woff2";